// extracted by mini-css-extract-plugin
export default {"container":"style_container__lVn36","scroll":"style_scroll__Y4+zt","buttonContainer":"style_buttonContainer__Q9Zn2","reset":"style_reset__kSBoI","submit":"style_submit__K-sEl"};